var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"28":1,"204":1,"239":1,"263":1,"307":1,"342":1,"354":1,"461":1,"526":1,"569":1,"614":1,"759":1,"909":1,"1003":1,"1031":1,"1064":1,"1080":1,"1124":1,"1252":1,"1458":1,"1483":1,"1636":1,"1705":1,"1789":1,"1805":1,"1858":1,"1912":1,"1962":1,"1978":1,"1992":1,"2069":1,"2098":1,"2296":1,"2580":1,"2626":1,"2673":1,"2725":1,"2735":1,"2807":1,"2879":1,"3063":1,"3129":1,"3130":1,"3145":1,"3157":1,"3160":1,"3315":1,"3333":1,"3404":1,"3493":1,"3690":1,"3829":1,"3907":1,"3992":1,"4106":1,"4179":1,"4243":1,"4341":1,"4441":1,"4507":1,"4836":1,"4884":1,"4908":1,"4910":1,"5218":1,"5237":1,"5276":1,"5331":1,"5446":1,"5450":1,"5521":1,"5592":1,"5607":1,"5951":1,"6242":1,"6278":1,"6289":1,"6552":1,"6581":1,"6586":1,"6605":1,"6700":1,"6872":1,"6975":1,"7107":1,"7350":1,"7461":1,"7508":1,"7589":1,"7727":1,"7766":1,"7817":1,"7855":1,"8051":1,"8108":1,"8332":1,"8338":1,"8351":1,"8353":1,"8551":1,"8765":1,"8916":1,"9015":1,"9140":1,"9141":1,"9407":1,"9450":1,"9494":1,"9715":1,"9716":1,"9752":1,"9818":1,"9892":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr